export class Organization {

  orgUnitId!: string;
  description!: string;
  pbcId!: string;
  pbcDescription!: string;
  responsibilityId!: string;
  responsibilityDescription!: string;
  serviceRepId!: string;
  serviceRepDescription!: string;
  applicationEngineerId!: string;
  applicationEngineerDescription!: string;
  controllingOrgId!: string;
  controllingOrgDescription!: string;
  smallTextUserField2!: string;
  smallTextUserField3!: string;
  smallTextUserField4!: string;
  smallTextUserField5!: string;
  mnemonic!: string;
  erpReferenceId!: string;
  createUser!: string;
  createTimestamp!: Date;
  updateUser!: string;
  updateTimestamp!: Date;
  typeCode!: string;
  typeDescription!: string;
  priceListId!: string;
  priceListDescription!: string;
  installCode!: string;
  installDescription!: string;
  paymentTermsCode!: string;
  paymentTermsDescription!: string;
  deliveryTermsCode!: string;
  deliveryTermsDescription!: string;
  transportationTermsCode!: string;
  transportationTermsDescription!: string;
  freightTermsCode!: string;
  freightTermsDescription!: string;
  classificationCode!: string;
  classificationDescription!: string;
  statusCode!: string;
  statusDescription!: string;
  siteStatusCode!: string;
  siteStatusDescription!: string;
  customerStatusCode!: string;
  customerStatusDescription!: string;
  channelStatusCode!: string;
  channelStatusDescription!: string;
  active!: boolean;
  masterOrganization!: boolean;
  site!: boolean;
  customer!: boolean;
  channel!: boolean;
  vendor!: boolean;
  validBuyingOrg!: boolean;
  validSellingOrg!: boolean;
  parentOrg!: string;
  smallTextUserField1!: string;
  dateUserField1!: Date;
  dateUserField2!: Date;
  dateUserField3!: Date;
  dateUserField4!: Date;
  dateUserField5!: Date;
  largeTextUserField1!: string;
  largeTextUserField2!: string;
  largeTextUserField3!: string;
  largeTextUserField4!: string;
  largeTextUserField5!: string;

}
